
import {getStyle} from './../general/Util';

import GoogleHandler from './../general/Google.js'


const getIconStyle = () => {
	switch ( getStyle() ) {

		case 'giga':
		case 'gigasport':
			return 'gs';

		case 'koe':
		default:
			return 'koe';
	}
}

class ClickAndReserveMap {

	constructor( containerEl ) {

		this.containerEl = containerEl;

		// Show map, if needed.
		this.containerEl.addEventListener( 'click', ( ev ) => {
			// Show Map.
			if ( ev.target.closest( '.mdl_stock_reserve__location_show_map' ) ) {
				this.setLocationOnMap();
			}
			// Select nearest location.
			if ( ev.target.closest( '.mdl_stock_reserve__location_button_current_selection' ) ) {
				this.selectNearestLocation();
			}
		})

		this.containerEl.addEventListener( 'update_location.acl', () => this.setLocationOnMapIfVisible() );
	}

	setLocationOnMapIfVisible() {

		// Update Map, if visible.
		const buttonEl = this.containerEl.querySelector( '.mdl_stock_reserve__location_show_map' );
		if ( buttonEl && buttonEl.matches( '.active' ) ) {
			this.setLocationOnMap();
		}
	}

	setLocationOnMap() {

		return GoogleHandler.getGoogleApi( ['marker'] ).then( ( google ) => {

			const canvasEl = this.containerEl.querySelector( '.map_canvas' );
			const MapWrapper = EN_KO.functions.initMap( canvasEl );

			const selectEl = this.containerEl.querySelector( '#shipping-location-select' );
			const selectedEl = Array.from( selectEl.options ).find( optionEl => optionEl.selected );
			const position = new google.maps.LatLng( parseFloat( selectedEl.dataset.attrLat ), parseFloat( selectedEl.dataset.attrLng ) );

			const url = new URL( 'https://www.google.com/maps/search/' );
			url.searchParams.append( 'api', 1 );
			url.searchParams.append( 'query', position.toUrlValue() );

			const location = [
				selectedEl.innerText.trim(),
				position.lat(),
				position.lng(),
				getIconStyle(),
				20,
				url.toString()
			];

			MapWrapper.setMarkers( [location] );
			MapWrapper.fitBounds();
			return MapWrapper;
		} );
	}

	selectNearestLocation() {

		if ( navigator.geolocation ) {
			navigator.geolocation.getCurrentPosition( (result) => {

				const user_lat = result.coords.latitude;
				const user_lng = result.coords.longitude;

				const selectEl = this.containerEl.querySelector( '#shipping-location-select' );
				const optionEls = Array.from( selectEl.options );

				const locations = [];
				optionEls.forEach( ( optionEl, idx ) => {

					const option_lat = parseFloat( optionEl.dataset.attrLat );
					const option_lng = parseFloat( optionEl.dataset.attrLng );

					if ( ! isNaN( option_lat ) && ! isNaN( option_lng ) ) {

						// Calculate Distance.
						const distance = EN_KO.functions.latlngdistance( user_lat, user_lng, option_lat, option_lng, 'K' );
						locations[ idx ] = {
							'distance' : distance,
							'obj' : optionEl,
							'lat' : option_lat,
							'lng' : option_lng
						};
					} else {

						if ( optionEl.disabled ) {

							locations[ idx ] = {
								'distance' : -1,
								'obj' : optionEl,
							};
						} else {

							locations[ idx ] = {
								'distance' : 99999999,
								'obj' : optionEl,
							};
						}

					}
				});

				// Custom sort function to sort JSON by distance ASC
				locations.sort( ( a, b ) => {
					return a.distance - b.distance;
				});

				// Empty select and refill it with sorted options
				selectEl.innerHTML = '';
				locations.forEach( loc => {

					if ( typeof loc === 'object' && loc.hasOwnProperty( 'obj' ) ) {
						selectEl.appendChild( loc.obj );
					}
				} );

				// Select the first (nearest) option.
				const firstOption = Array.from( selectEl.options ).find( ( optionEl ) => ! optionEl.matches( ':disabled' ) );
				selectEl.value = firstOption.value;
				selectEl.dispatchEvent( new Event( 'change', { bubbles: true } ) );

				// console.log(locations);
			}, function(error){
				console.log("Error-Code: " + error.code);
				console.log("Error-Message: " + error.message);

				this.containerEl.querySelector( '.mdl_stock_reserve__location_error' ).classList.add( 'is-active' );
				console.log("There was a problem while we tried to get the current location!");
			});
		} else {
			this.containerEl.querySelector( '.mdl_stock_reserve__location_error' ).classList.add( 'is-active' );
			console.log("Navigator not available! No GeoLoation can be determined!");
		}
	}
}

export default ClickAndReserveMap;
